import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'lohi-nav-bar-performance',
  templateUrl: './nav-bar-performance.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBarPerformanceComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
